import type { CSSProperties } from 'react';
import { addUnit } from '@shared/helpers/string.helpers';
import { toNumber } from 'lodash';

type HideOutsideViewportSlotStyleInput = {
  width: string | number;
  height: string | number;
  /**
   * When true, the empty slot keeps a definite height so a long list can
   * still overflow. When omitted or false, only minHeight is set (the
   * develop-era list layout).
   */
  cullBeforeMount?: boolean;
};

/**
 * Layout for a {@link HideOutsideViewport} row slot.
 * Always reserves {@link HideOutsideViewportSlotStyleInput.height} as minHeight
 * so culled or empty rows still contribute to list overflow.
 */
export const getHideOutsideViewportSlotStyle = ({
  width,
  height,
  cullBeforeMount = false,
}: HideOutsideViewportSlotStyleInput): CSSProperties => ({
  width: addUnit(width),
  minHeight: addUnit(height),
  ...(cullBeforeMount
    ? { height: addUnit(height), flexShrink: 0, boxSizing: 'border-box' }
    : {}),
  scrollMarginTop: addUnit(toNumber(height) * 2),
  scrollMarginBottom: addUnit(toNumber(height) * 2),
});
